module.exports = __webpack_public_path__ + "fc0069bccd016c23a7bda555ca402115.jpg";